import { createFileRoute } from '@tanstack/react-router';
import { PackAdminPage } from '../../../features/packs/pack-admin-page.tsx';
import { validatePackSearch } from '../../../features/packs/pack-search.ts';
import { guardPermission } from '../../../shell/guard.ts';

// Content packs (T14, spec J7). `?version=` keeps the uploaded pack's diff open across reloads.
export const Route = createFileRoute('/_authed/admin/packs')({
  validateSearch: validatePackSearch,
  beforeLoad: guardPermission('pack.manage'),
  component: PacksRoute,
});

function PacksRoute(): React.JSX.Element {
  const { version } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PackAdminPage
      version={version}
      onVersion={(next) => void navigate({ search: { version: next } })}
    />
  );
}
